<template>
    <form >
        <div class="primary-item">
            <ui-input
                v-model="dataModels.first_name"
                type="text"
                label="Nome Completo:"
                size="md2" />
        </div>
        <div>  
            <div>
                <ui-input
                    v-model="dataModels.cpf"
                    type="text"
                    :label="cpfInvalido"
                    :color-label="cpfInvalido == 'CPF:' ? '#4a586c' : 'red'"
                    size="md2"
                    mask="###.###.###-##"
                    :blur="verifyCPF(dataModels.cpf)" />
            </div>
            <div>
                <ui-input
                    v-model="dataModels.creci"
                    label="CRECI:"
                    size="md2" />
            </div>
        </div>
        <div>
            <div>
                <ui-select
                    v-model="dataModels.sex"
                    label="Sexo:" >
                    <option
                        value="m"
                        :selected="
                            dataModels.sex == 'm'
                        "
                    >
                        Masculino
                    </option>
                    <option
                        value="f"
                        :selected="
                            dataModels.sex == 'f'
                        "
                    >
                        Feminino
                    </option>
                </ui-select>
            </div>
            <!--*************************
            **** Estado Civil ***********
            **************************-->
            <div>
                <ui-select v-if="dataModels.sex == 'f'" v-model="dataModels.civil_status" label='Estado Civil'>
                    <option
                        v-for="options in estadoCivil" :key="options.id"
                        :value="options.feminino"
                        :selected=" options.feminino == dataModels.civil_status"
                    >
                        {{options.feminino}}
                    </option>
                </ui-select>
                <ui-select v-else v-model="dataModels.civil_status" label='Estado Civil'>
                    <option
                        v-for="options in estadoCivil" :key="options.id"
                        :value="options.masculino"
                        :selected=" options.masculino == dataModels.civil_status"
                    >
                        {{options.masculino}}
                    </option>
                </ui-select>
            </div>
        </div>
        <div class="date">
            <div>
                <ui-datepicker
                    v-model="dataModels.birthday" 
                    :value="dataModels.birthday"
                    :min-date='new Date(1900, 0, 1)' 
                    :max-date='new Date()'
                    :context="'notFuture'"
                    class='camp-date'
                    size="md"
                    label="Nascimento:"  />
            </div>
        </div>
    </form>
</template>

<script>
import helpers from '@/mixins/helpers'
import { uiSelect, uiInput, uiDatepicker } from '@/components/ui/form'

export default {
    name: 'ui-user-data',

    components: {
        uiDatepicker,
        uiInput,
        uiSelect
    },

	mixins: [helpers],

	props: {
		userModel: {
			type: [Object, String],
			default: () => {},
		},
		cpfInvalido: {
			type: String,
			default: '',
		},
	},

	data() {
		return {
			estadoCivil: [
				{ masculino: 'Solteiro', feminino: 'Solteira' },
				{ masculino: 'Casado', feminino: 'Casada' },
				{ masculino: 'Divorciado', feminino: 'Divorciada' },
				{ masculino: 'Viúvo', feminino: 'Viúva' },
			],
			dataModels: this.userModel,
		}
	},

	watch: {
		userModel(val) {
			this.dataModels = val
		},
	},

	methods: {
		verifyCPF(cpf) {
			if (cpf) {
				if (cpf.length === 14) {
					var breakApartCpf = cpf.split('')
					/**
					 * removendo os pontos e o traço do cpf
					 */
					var removeFeatureAndScore = breakApartCpf.filter((e) => e !== '.' && e !== '-')
					/**
					 * comparando quantidade de caractere e verificando se cpf é válido
					 */
					if (this.validateCpf(removeFeatureAndScore.join('')) == false) {
						this.mensageErros('cpf')
					} else {
						this.mensageErros('remove-cpf')
					}
				} else if (cpf.length == 0) {
					this.mensageErros('remove-cpf')
				}
			} else {
				this.mensageErros('remove-cpf')
			}
		},
		mensageErros(value) {
			this.$emit('imput', value, null)
		},
	}
}
</script>

<style lang='stylus' scoped>
@import '../styles.styl';
</style>